import { graphql } from '@/generated/gql';

export const LOAD_ABSENCES_QUERY = graphql(/* GraphQL */ `
  query LoadAbsences($userId: UUID, $where: AstroAbsenceListWhereInput) {
    astronaut {
      user(id: $userId) {
        id
        primarySourceReference
        absences(where: $where) {
          nodes {
            id
            start
            end
          }
        }
      }
    }
  }
`);
